// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"f4a26f45","809":"14021f99"}[chunkId] + ".chunk.css";
};